import { render, staticRenderFns } from "./MinhaInscricao.vue?vue&type=template&id=1d4588b4"
import script from "./MinhaInscricao.vue?vue&type=script&lang=js"
export * from "./MinhaInscricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports